import { useQuery } from '@tanstack/react-query'
import { activityApi } from '@/lib/api'

export function useActivity(limit = 50) {
  return useQuery({
    queryKey: ['activity', limit],
    queryFn: () => activityApi.list(limit),
    staleTime: 30_000,
  })
}
